import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import { emphasize } from '@material-ui/core/styles/colorManipulator';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import React from "react";
import Select from 'react-select';
import WebServices from '../../WebServices';
import { debounce, sortBy,pullAllBy } from 'lodash';
import CircularProgress from '@material-ui/core/CircularProgress';
import Avatar from '@material-ui/core/Avatar';
import ListItemAvatar from '@material-ui/core/ListItemAvatar'

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: 250,
  },
  input: {
    display: 'flex',
    padding: 0,
  },
  valueContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: 1,
    alignItems: 'center',
  },
  chip: {
    margin: '18px',
  },
  chipFocused: {
    backgroundColor: emphasize(
      theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700],
      0.08,
    ),
  },
  noOptionsMessage: {
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`,
  },
  singleValue: {
    fontSize: 16,
  },
  placeholder: {
    position: 'absolute',
    left: 2,
    fontSize: 16,
  },
  paper: {
    position: 'absolute',
    zIndex: 1,
    marginTop: theme.spacing(1),
    left: 0,
    right: 0,
  },
  divider: {
    height: theme.spacing(2),
  },
});



const inputComponent = ({ inputRef, ...props }) => <div ref={inputRef} {...props} />;

const NoOptionsMessage = props =>
  (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.noOptionsMessage}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );


const Option = props => {
  let user = JSON.parse(props.children);
  return (
    <ListItem
      selected={props.isFocused}
      component="div"
      style={{
        fontWeight: props.isSelected ? 500 : 400,
      }}
      {...props.innerProps}
    >
      {user.bun &&
      <ListItemAvatar>
        <Avatar src={`/api/users/userImage?bun=${user.bun}`} />
         </ListItemAvatar>
      }
      <ListItemText primary={user.name} secondary={user.bun ? user.bun : user.email} />
    </ListItem>
  )
};

const Placeholder = props =>
  (
    <Typography
      color="textSecondary"
      className={props.selectProps.classes.placeholder}
      {...props.innerProps}
    >
      {props.children}
    </Typography>
  );


const SingleValue = props =>
  (
    <Typography className={props.selectProps.classes.singleValue} {...props.innerProps}>
      {props.children}
    </Typography>
  );


const ValueContainer = props => {
  return <div className={props.selectProps.classes.valueContainer}>{props.children}</div>;
}


const Menu = (props) => (
  <Paper square className={props.selectProps.classes.paper} {...props.innerProps}>
    {props.children}
  </Paper>
);

const Control = (props) =>
  (
    <TextField
      fullWidth
      InputProps={{
        inputComponent,
        inputProps: {
          className: props.selectProps.classes.input,
          inputRef: props.innerRef,
          children: props.children,
          ...props.innerProps,
        },
      }}
      {...props.selectProps.textFieldProps}
    />
  );

const Tooltip = (props) => (
  <Tooltip content="Search name or bun">
    <components.NoOptionsMessage {...props} />
  </Tooltip>
)

const components = {
  Tooltip,
  Control,
  Menu,
  NoOptionsMessage,
  Option,
  Placeholder,
  SingleValue,
  ValueContainer,
};

class UserLookupSelect extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      users: [],
      searchTerm: '',
      selectedUser: null,
      loading: false
    }

    this.webServices = new WebServices();
  }

  updateOptions(searchTerm) {
    this.setState({ loading: true });
    const {usersToExclude = [], searchMethod = 'searchActiveDirectory' } = this.props;
    const searchFunction = typeof this.webServices[searchMethod] === 'function'
      ? this.webServices[searchMethod].bind(this.webServices)
      : this.webServices.searchActiveDirectory.bind(this.webServices);

    searchFunction(searchTerm)
      .then((users) => {
        if (this.state.searchTerm === searchTerm) {
          users = sortBy(users, 'name');
          const excludedUsers = usersToExclude.map(user => ({...user,bun:user.bun ? user.bun.toUpperCase() : user.bun }));
          users = users.map(user => ({...user,bun:user.bun ? user.bun.toUpperCase() : user.bun}));
          users = pullAllBy(users,excludedUsers,'bun');
          this.setState({ users })
          this.setState({ loading: false });
        }
      })
      .catch((error) => {
        console.log(error);
        this.setState({ loading: false });
      });
  }

  clearSearch() {
    this.setState({ users: [], searchTerm: '', loading: false })
  }

  render() {
    let usersJson = this.state.users.map(user => {

      let json = JSON.stringify(user);
      return { label: json }
    });

    const { classes, theme } = this.props;
    const selectStyles = {
      input: base => ({
        ...base,
        color: theme.palette.text.primary,
        '& input': {
          font: 'inherit',
        },
      }),
    };

    const updateOptions = debounce((searchTerm) => {
      this.updateOptions(searchTerm);
    }, 300);

    return (

      <div className="form-field-padding">
        <Grid container>
          <Grid item xs={8}>
            <Select
              inputValue={this.state.searchTerm}
              classes={classes}
              styles={selectStyles}
              options={usersJson}
              components={components}
              value={this.state.selectedUser}
              onChange={(userLookupJson) => {
                try{
                  let user = userLookupJson ? JSON.parse(userLookupJson.label) : null;
                  this.props.onUserSelected(user);
                }catch(error) {
                }
              }}              
              placeholder={this.props.placeHolder ? this.props.placeHolder : 'Search Users'}
              onInputChange={(searchTerm) => {
                if (!searchTerm) {
                  this.clearSearch();
                } else {
                  this.setState({ searchTerm })
                  updateOptions(searchTerm)
                }
              }}
            />
          </Grid>
          <Grid item xs={1}>
            {this.state.loading && <CircularProgress className={classes.progress} size={20} />}
          </Grid>
        </Grid>
      </div>
    );
  }
}



export default withStyles(styles, { withTheme: true })(UserLookupSelect);
